import {createSlice} from '@reduxjs/toolkit'


const chatbotFlow = createSlice({
    name: 'chatbotFlow',
    initialState: {
        flow: {},
        loading: false,
        isSubmittingConversation: false, //if conversation is being submitted to the server
        hasConversationSubmitFailed: false, //the server never accepted the conversation
        activeGroupId: 0,
        conversation: [],
        index: 0,
        data: [], //Candidates or Jobs
        dataLoading: false,
        isFinished: false,
        asyncMessageTimerID: 0
    },
    reducers: {
        setFlow: (state, action) => {
            let flow = action.payload
            state.flow = flow
            state.activeGroupId = flow.groups[0].id
        },
        setActiveGroupId: (state, action) => {
            state.activeGroupId = action.payload
        },
        addBlock: (state, action) => {
            let block = action.payload;
            state.index = state.index + 1
            block = Object.assign({index: state.index, groupId: state.activeGroupId}, block);
            state.conversation.push(block)
        },
        setTimerID: (state, action) => {
            state.asyncMessageTimerID = action.payload
        },
        clearTimerID: (state) => {
            state.asyncMessageTimerID = 0
        },
        addAnswer: (state, action) => {
            const answer = action.payload
            const activeBlock = state.conversation.pop()
        
            if (
                activeBlock.dataType == "CANDIDATE_VINCERE_GDPR_CONSENT_TO_KEEP" ||
                activeBlock.dataType == "CANDIDATE_VINCERE_GDPR_RIGHT_TO_REPRESENT"
            ) {
                const matchedAnswer = activeBlock.options?.answers?.find(item => item.title == answer);
                if (matchedAnswer) {
                    activeBlock.answer = matchedAnswer.id == 1 ? "Yes" : matchedAnswer.id == 2 ? "No" : answer;
                    activeBlock.answerForDisplay = matchedAnswer;
                }
            } else if (answer.type == 'date') {
                activeBlock.answer = answer.formattedDatesForBackend; // Add backend compatible format
                activeBlock.answerForDisplay = answer.formattedDates; // Display user choice on frontend
            }
            else if (activeBlock.dataType == 'CONTACT_VINCERE_STATUS') {
                const matchedAnswer = activeBlock.options?.answers?.find(item => item.title == answer);
                if (matchedAnswer) {
                    activeBlock.answer = matchedAnswer;
                    activeBlock.answerForDisplay = matchedAnswer;
                }
            } 
            else {
                activeBlock.answer = answer;
            }
            state.conversation.push(activeBlock)
        },
        noData: (state) => {
            const activeBlock = state.conversation.pop()
            activeBlock.noData = true;
            activeBlock.answer = [];
            state.conversation.push(activeBlock)
        },
        skipBlock: (state) => {
            const activeBlock = state.conversation.pop()
            activeBlock.isSkipped = true;
            activeBlock.answer = "";
            state.conversation.push(activeBlock)
        },
        rewindToBlock: (state, action) => {
            const blockIndex = action.payload
            state.conversation = state.conversation.filter(block => block.index <= blockIndex)
            const activeBlock = state.conversation.pop()
            activeBlock.isSkipped = false;
            activeBlock.answer = null;
            state.activeGroupId = activeBlock.groupId;
            state.conversation.push(activeBlock)
            state.index = blockIndex;
            state.loading = false;
            state.isFinished = false;
        },
        resetFlow: (state) => {
            state.index = 1;
            state.conversation = [];
            state.activeGroupId = state.flow.groups[0].id
            state.loading = false;
            state.isFinished = false;
        },
        finishChat: (state) => {
            state.isFinished = true;
        },
        showLoading: (state, action) => {
            state.loading = action.payload;
        },
        setIsSubmittingConversation: (state, action) => {
            state.isSubmittingConversation = action.payload;
        },
        setHasConversationSubmitFailed: (state, action) => {
            state.hasConversationSubmitFailed = action.payload;
        },
        setData: (state, action) => {
            let data = action.payload;
            if (data.length > 20) {
                data = data?.filter((item, i) => i < 20)//Max 20
            }
            state.data = data
        },
        setDataLoading: (state, action) => {
            state.dataLoading = action.payload;
        },
    }
})

export const {
    setFlow, setActiveGroupId, addBlock, addAnswer, skipBlock, rewindToBlock, setIsSubmittingConversation,
    setHasConversationSubmitFailed, resetFlow, finishChat, showLoading, setData, setTimerID, clearTimerID,
    noData, setDataLoading
} = chatbotFlow.actions

export default chatbotFlow.reducer